"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TriggerTypeEnum = void 0;
// TODO: Move to a const, it's not an enum if it has only one element
var TriggerTypeEnum;
(function (TriggerTypeEnum) {
    TriggerTypeEnum["EVENT"] = "event";
})(TriggerTypeEnum || (exports.TriggerTypeEnum = TriggerTypeEnum = {}));
//# sourceMappingURL=notification-trigger.interface.js.map